import React, { useState } from 'react'
import { Form, Input, Button } from 'antd';

const TextInput = (props) => {
    const [text, setText] = useState('');

    const inputStyle = {marginBottom: '0'}

    const onChange = (e) => {
        setText(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        props.handleSubmit(text)
    }

    return (
        <Form layout='vertical'>
            <Form.Item
                name="text"
                initialValue={props.initialValue}
                label={props.label}
                style={inputStyle}
                rules={[
                    {
                        required: true,
                        message: props.label + ' is required',
                    }
                ]}
            >
                <Input.TextArea
                    className={props.className}
                    placeholder={props.placeholder}
                    autoSize={{ minRows: 2, maxRows: 6 }}
                    onChange={onChange}
                />
            </Form.Item>
            <Form.Item style={inputStyle} >
                <Button block type="primary" htmlType="submit" onClick={handleSubmit}>{props.buttonText}</Button>
            </Form.Item>
        </Form>
    );
}

export default TextInput;